import { render, staticRenderFns } from "./PageSkeleton.vue?vue&type=template&id=136307f5&scoped=true"
import script from "./PageSkeleton.vue?vue&type=script&lang=js"
export * from "./PageSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PageSkeleton.vue?vue&type=style&index=0&id=136307f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136307f5",
  null
  
)

export default component.exports